import useRollupContext from "@app/analytics/hooks/meetops/useRollupContext";
import useTopicReports from "@app/analytics/hooks/topics/useTopicReports";
import { useAuthenticated } from "@app/common/auth/useAuth";
import useMeetings from "@app/common/hooks/meetings/useMeetings";
import type { DateRange } from "@app/common/types";

const useFetchMeetingsInBackground = ({
  dateRanges,
}: {
  dateRanges: DateRange[];
}) => {
  const { user } = useAuthenticated();
  const { teamId, userId } = useRollupContext();

  const incompleteMeetingsQuery = useMeetings({
    dateRanges,
    workspaceId: user.workspaceId,
    userId,
    teamId,
    view: "incomplete",
  });

  const sharedWithMeMeetingsQuery = useMeetings({
    dateRanges,
    userId,
    teamId,
    view: "shared_with_me",
  });

  const sharedWithMeTopicsQuery = useTopicReports({
    dateRange: dateRanges[0],
    view: "shared_with_me",
  });

  return {
    incompleteMeetingsQuery,
    sharedWithMeMeetingsQuery,
    sharedWithMeTopicsQuery,
  };
};

export default useFetchMeetingsInBackground;
